import React, { FC } from 'react';
import { ContentImage } from 'components/ContentImage/ContentImage';
import styles from './ItemIcon.module.scss';
import { ContentImageEntry } from 'api/contentful/contentTypes.cloverdotcom';

interface ItemIconProps {
  icon?: ContentImageEntry;
}

export const ItemIcon: FC<ItemIconProps> = ({ icon }) => {
  if (!icon) return null;

  return <ContentImage className={styles.icon} entry={icon} isLazyLoad={false} />;
};
